var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failure"},[_c('i',{staticClass:"el-icon-warning"}),_c('p',[_vm._v("银行基本户认证失败")]),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }